<template>
  <v-container>
    <v-row>
      <v-col cols="12">
        <add-project></add-project>
      </v-col>
      <v-dialog v-model="projectDialog">
        <v-card>
          <v-card-title class="break-word">
            {{ selectedProject.name }}
          </v-card-title>
          <v-card-subtitle>
            {{ selectedProject.description }}
          </v-card-subtitle>
          <v-card-subtitle v-if="admin.boardMember">
            Submitted By {{ selectedProject.creator }}
          </v-card-subtitle>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="accent" text @click="projectDialog = false">
              close
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
      <v-col cols="12">
        <v-list two-line align="left">
          <v-list-item-group v-model="selected" active-class="teal--text">
            <template v-for="(project, index) in projects">
              <v-list-item
                :key="project.id"
                @click="toProjectProfile(project.id)"
              >
                <template v-slot:default="{ active }">
                  <v-list-item-avatar>
                    <v-avatar color="accent" class="white--text"> KL </v-avatar>
                  </v-list-item-avatar>
                  <v-list-item-content>
                    <v-list-item-title
                      v-text="project.name"
                    ></v-list-item-title>

                    <v-list-item-subtitle
                      class="text--primary"
                      v-text="project.description"
                    >
                    </v-list-item-subtitle>
                  </v-list-item-content>

                  <v-list-item-action>
                    <v-list-item-action-text
                      v-text="project.date"
                    ></v-list-item-action-text>
                    <v-btn
                      icon
                      @click="deleteProject(project)"
                      v-if="admin.boardMember"
                      color="secondary"
                    >
                      <v-icon small>fas fa-trash</v-icon>
                    </v-btn>
                  </v-list-item-action>
                </template>
              </v-list-item>

              <v-divider
                v-if="index < projects.length - 1"
                :key="index"
              ></v-divider>
            </template>
          </v-list-item-group>
        </v-list>
        <v-snackbar
          v-model="snackbar"
          color="info darken-1"
          :timeout="3000"
          light
          top
        >
          <v-avatar icon>
            <v-icon color="white" small>check</v-icon>
          </v-avatar>
          {{ snackbarMessage }}
          <v-btn text @click="snackbar = false">Close</v-btn>
        </v-snackbar>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import { firebaseApp, projectsRef } from "../../../firebaseApp";
import AddProject from "./AddProject.vue";

export default {
  components: { AddProject },
  data: () => ({
    projects: [],
    projectDialog: false,
    active: false,
    member: {},
    admin: {},
    selected: [],
    selectedProject: {},
    snackbar: false,
    snackbarMessage: "",
  }),
  methods: {
    loadMemberInfo() {
      this.member = this.$store.state.member;
      this.admin = this.$store.state.admin;
    },
    formatDate(timestamp) {
      var formattedDate = new Date(timestamp);
      formattedDate = formattedDate.toLocaleDateString("en-US");
      return formattedDate;
    },
    openProject(project) {
      this.selectedProject = project;
      this.projectDialog = true;
    },
    toProjectProfile(projectId) {
      this.$router.push("/project/" + projectId);
    },
    deleteProject(project) {
      firebaseApp
        .database()
        .ref("/projects/" + project.id)
        .remove()
        .then(
          (this.snackbar = true),
          (this.snackbarMessage = "project was deleted")
        );
      this.loadProjects();
    },
    loadProjects() {
      var communityCode = this.member.communityCode;
      projectsRef.on("value", (snap) => {
        var projects = [];
        snap.forEach((prj) => {
          if (communityCode == prj.val().communityCode) {
            let project = {};
            project = prj.val();
            project.id = prj.key;
            project.date = this.formatDate(project.dateAdded);
            projects.push(project);
          }
        });
        var ordered = projects.reverse();
        this.projects = ordered;
      });
    },
  },
  mounted() {
    this.loadMemberInfo();
    this.loadProjects();
  },
};
</script>